import NewsPage from "../news/NewsPage";
import Mpdata from "../../pages/mp/Mpdata";

const Dharm = () => {
  return (
    <NewsPage
      category="धर्म"
      categoryAliases={["धर्म", "religion", "dharm"]}
    />
  );
};

export default Dharm;
